import Ajax from "Utils/ajax";
export const getPositionsList = (data) => Ajax.post('career/getPositionsList',data); 
export const addUpdatePosition = (data) => Ajax.post('career/addUpdatePosition',data); 
export const removeRow = (data) => Ajax.post('career/removePosition',data); 